import { ExternalLink } from 'lucide-react';
import { Button, toast } from '@/components/ui';
import { ARTIST_LINK_MALLS, artistSlug, buildStorefrontArtistUrl } from '../lib/storefrontArtistUrl';

/**
 * QA-562 아티스트 상세 — 쇼핑몰 아티스트 페이지 4몰 짧은 주소. [열기]는 새 창, [복사]는 SNS 업로드용(QA-561).
 */
export const ArtistStorefrontLinks = ({ artistId, stageName }: { artistId: string; stageName: string }) => {
  const hasSlug = artistSlug(stageName) !== '';
  const copy = async (url: string) => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('주소를 복사했습니다.');
    } catch {
      toast.error('복사하지 못했습니다. 주소를 직접 선택해 복사해 주세요.');
    }
  };
  return (
    <div className="flex flex-col gap-1.5" data-testid="artist-storefront-links">
      {ARTIST_LINK_MALLS.map((m) => {
        const url = buildStorefrontArtistUrl({ artistId, stageName }, m.mall);
        return (
          <div key={m.mall} className="flex flex-wrap items-center gap-2 text-[13px]" data-testid="artist-storefront-link-row">
            <span className="w-14 shrink-0 text-[color:var(--content-muted)]">{m.label}</span>
            <a href={url} target="_blank" rel="noopener noreferrer" className="min-w-0 flex-1 truncate underline" title={url}>
              {url}
            </a>
            <Button type="button" size="sm" variant="ghost" onClick={() => void copy(url)} data-testid="artist-storefront-copy">
              복사
            </Button>
          </div>
        );
      })}
      {hasSlug ? null : (
        <p className="text-[11px] text-[color:var(--content-muted)]">활동명에 영문·숫자가 없어 짧은 주소를 만들 수 없습니다(긴 주소).</p>
      )}
    </div>
  );
};

/** 목록·헤더용 — 한국몰 페이지를 새 창으로. */
export const ArtistStorefrontOpenLink = ({ artistId, stageName, label }: { artistId: string; stageName: string; label?: string }) => (
  <a
    href={buildStorefrontArtistUrl({ artistId, stageName })}
    target="_blank"
    rel="noopener noreferrer"
    onClick={(e) => e.stopPropagation()}
    className="inline-flex items-center gap-1 text-xs text-[color:var(--content-muted)] hover:underline"
    title="쇼핑몰에서 보기(새 창)"
    aria-label={`${stageName} 쇼핑몰에서 보기`}
    data-testid="artist-storefront-open"
  >
    <ExternalLink size={12} aria-hidden="true" />
    {label ?? null}
  </a>
);
